import React from 'react';
import PropTypes from 'prop-types';
import { getFromLocalStorage } from '../../utils/browser-storage';

////////////////////////////////////////////
// TODO MISSING TESTS
////////////////////////////////////////////

const SocialButtons = props => {
  const socialCookies = getFromLocalStorage('userAcceptsSocialCookies') === 'true' ? true : false;
  const locale = props.locale.toLowerCase();

  const twitterSrc = `https://platform.twitter.com/widgets/follow_button.9c00c8ca14a8618c4db8e2c43139b138.${locale}.html#dnt=false&id=twitter-widget-0&lang=${locale}&screen_name=sportograf&show_count=false&show_screen_name=false&size=l&time=1516004729689`
  const facebookSrc = `https://www.facebook.com/v6.0/plugins/like.php?app_id=113869198637480&channel=https%3A%2F%2Fstaticxx.facebook.com%2Fconnect%2Fxd_arbiter.php%3Fversion%3D46%23cb%3Df908413f4338a4%26domain%3Ddevelopers.facebook.com%26origin%3Dhttps%253A%252F%252Fdevelopers.facebook.com%252Ffe26fa918ccb14%26relation%3Dparent.parent&container_width=735&href=https%3A%2F%2Fwww.facebook.com%2Fsportograf&layout=button_count&locale=${locale}&sdk=joey&share=false&size=large`
  return (
    <div>
      {socialCookies && 
        <div className="social-buttons-container">
          <div className="social-buttons-instagram">
            <a
              href="https://www.instagram.com/sportograf/?ref=badge"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="Instagram" src="/images/instagram.png" />
            </a>
          </div>
          <div className="social-buttons-twitter">
            <iframe
              id="twitter-widget-0"
              scrolling="no"
              frameBorder="0"
              allowtransparency="true"
              title="Twitter Follow Button"
              src={twitterSrc}
              data-screen-name="sportograf"
            />
          </div>
          <div className="social-buttons-facebook">
            <div
              data-action="like"
              data-href="https://www.facebook.com/sportograf"
              data-layout="button_count"
              data-show-faces="false"
            >
              <span>
                <iframe
                  name="f140e1f301faa38"
                  width="1000px"
                  height="1000px"
                  frameBorder="0"
                  allowtransparency="true"
                  allowFullScreen={true}
                  scrolling="no"
                  title="fb:like Facebook Social Plugin"
                  src={facebookSrc}
                />
              </span>
            </div>
          </div>
        </div>
      }
      {!socialCookies && 
        <div className="social-buttons-container">
          <div className="social-buttons-facebook">
            <a
              href="https://www.facebook.com/sportograf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="Instagram" src="/images/facebook.png" />
            </a>
          </div>
          <div className="social-buttons-twitter">
            <a
              href="https://twitter.com/sportograf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="Instagram" src="/images/twitter.png" />
            </a>
          </div>
          <div className="social-buttons-instagram">
            <a
              href="https://www.instagram.com/sportograf/?ref=badge"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="Instagram" src="/images/instagram.png" />
            </a>
          </div>
        </div>
      }
    </div>
  );
};

SocialButtons.defaultProps = {
  locale: "en-GB"
};

SocialButtons.propTypes = {
  locale: PropTypes.string,
};

export default SocialButtons;
